/**
 * Program 4b — FE mirrors of OrganizationMember.role ↔ PMS UserRole.
 */
export type OrgMemberRole = 'OWNER' | 'ADMIN' | 'AGENT' | 'CARETAKER' | 'MEMBER';

/** OrganizationMember.role → PMS role string used in UI gates. */
export function mapOrgMemberRoleToPmsRole(memberRole: string | null | undefined): string | null {
  switch ((memberRole || '').toUpperCase()) {
    case 'OWNER':
      return 'LANDLORD';
    case 'ADMIN':
      return 'ADMIN';
    case 'AGENT':
      return 'AGENT';
    case 'CARETAKER':
      return 'CARETAKER';
    case 'MEMBER':
      return 'CARETAKER';
    default:
      return null;
  }
}

/** True when membership (or legacy User.role) is portfolio owner. */
export function isOrgOwnerRole(opts: {
  membershipRole?: string | null;
  userRole?: string | null;
  effectivePmsRole?: string | null;
}): boolean {
  if ((opts.membershipRole || '').toUpperCase() === 'OWNER') return true;
  if (opts.effectivePmsRole === 'LANDLORD') return true;
  return opts.userRole === 'LANDLORD';
}

/** Effective PMS role for invite UI / permission bypass. */
export function resolveClientPmsRole(opts: {
  membershipRole?: string | null;
  userRole?: string | null;
  effectivePmsRole?: string | null;
}): string {
  if (opts.effectivePmsRole) return opts.effectivePmsRole;
  const fromOrg = mapOrgMemberRoleToPmsRole(opts.membershipRole);
  if (fromOrg) return fromOrg;
  return opts.userRole || 'CARETAKER';
}
